import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { CurrencyStatus } from '../types';

export const currenciesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'code',
    label: 'Numeric code',
  },
  {
    name: 'name',
    label: 'Character code',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'shouldCreateBalanceForClients',
    label: 'Default Availability',
  },
  {
    name: 'decimals',
    label: 'Precesion',
  },
  {
    name: 'active',
    label: 'Status',
  },
];

export const currenciesListColumnsLabels = {
  active: 'Status',
};

export const currenciesListSchema = {
  numericCode: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  name: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const currenciesListFiltersSchema = [
  {
    name: 'active',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'active',
        title: CurrencyStatus.ACTIVE,
        value: 'true',
      },
      {
        name: 'active',
        title: CurrencyStatus.DISABLED,
        value: 'false',
      },
    ],
  },
];
